import { defineMessages } from 'react-intl';

export default defineMessages({
  fourOhFourMessage: {
    defaultMessage: '404, missing page',
  },
});
